
export const displaySparkedOnStreetSuccessSelector = ({displaySparkedOnStreetSuccess}) => displaySparkedOnStreetSuccess